// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"6df21a29","732":"8f2f69c7"}[chunkId] + ".chunk.js";
};